import { useMemo } from "react";

const SPACE_REGEX = /\s+/g;

export const getCTAEvents = <T extends { publishEvent?: string }>(cta?: T | T[]): string | undefined => {
  const ctaArray = Array.isArray(cta) ? cta : [cta];
  if (!ctaArray?.length) return undefined;

  return (
    ctaArray
      ?.filter(
        (cta): cta is T & { publishEvent: string } =>
          typeof cta?.publishEvent === "string" && Boolean(cta?.publishEvent?.trim()),
      )
      .map((cta) => (cta.publishEvent ?? "").toString().trim().replace(SPACE_REGEX, "_"))
      .join(" ") || undefined
  );
};

const useCTAEvents = <T extends { publishEvent?: string }>(cta?: T | T[]) => {
  return useMemo(() => getCTAEvents(cta), [cta]);
};

export default useCTAEvents;
